/*
  Buy it now — собственная кнопка вместо динамической кнопки Shopify.

  Зачем: штатная кнопка (Apple Pay / Google Pay / Shop Pay) списывала картой сразу
  и уводила покупателя мимо чекаута. С 07.09.2026 в магазине включён Cash on Delivery —
  главный способ оплаты в ОАЭ, — и его нужно показать человеку до оплаты.

  Что делает: кладёт выбранный вариант в корзину и ведёт на /checkout, где видны
  все способы оплаты, включая оплату при получении.
  Если запрос не прошёл — молча откатывается на обычную отправку формы (товар просто
  уедет в корзину), чтобы кнопка ни при каких условиях не оказалась мёртвой.
*/
(function () {
  if (window.bazaBuyNowReady) return;
  window.bazaBuyNowReady = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-baza-buy-now]');
    if (!button || button.disabled) return;

    var form = button.closest('form[action*="/cart/add"]');
    if (!form) return;

    event.preventDefault();

    var variantField = form.querySelector('.product-variant-id, [name="id"]');
    var variantId = variantField && variantField.value;
    if (!variantId) {
      form.submit();
      return;
    }

    var quantityField = form.querySelector('[name="quantity"]');
    var quantity = parseInt(quantityField && quantityField.value, 10) || 1;

    button.setAttribute('aria-busy', 'true');
    button.classList.add('loading');
    button.disabled = true;

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart/add failed: ' + response.status);
        window.location.href = root + 'checkout';
      })
      .catch(function () {
        button.removeAttribute('aria-busy');
        button.classList.remove('loading');
        button.disabled = false;
        form.submit();
      });
  });
})();
